/** Lucide-style stroke иконки. Все 22×22, currentColor. */
import type { SVGProps } from 'react';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={22}
    height={22}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  />
);

export const IconHome = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-7h-2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /></SVG>
);

/** Иконка-входящие для вкладки «Запросы» (Manager). Lucide-style. */
export const IconInbox = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
    <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
  </SVG>
);

/** Иконка-окно с ламелями для вкладки «Каталог» (CLIENT). */
export const IconWindow = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <rect x={4} y={3} width={16} height={18} rx={2} />
    <line x1={4} y1={8} x2={20} y2={8} />
    <line x1={4} y1={12} x2={20} y2={12} />
    <line x1={4} y1={16} x2={20} y2={16} />
  </SVG>
);

export const IconCalendar = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <rect x={3} y={4} width={18} height={18} rx={2} />
    <line x1={16} y1={2} x2={16} y2={6} />
    <line x1={8} y1={2} x2={8} y2={6} />
    <line x1={3} y1={10} x2={21} y2={10} />
  </SVG>
);

export const IconMap = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6" />
    <line x1={8} y1={2} x2={8} y2={18} />
    <line x1={16} y1={6} x2={16} y2={22} />
  </SVG>
);

export const IconBell = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </SVG>
);

export const IconUser = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx={12} cy={7} r={4} />
  </SVG>
);

/** Несколько людей — вкладка «Роли» администратора. */
export const IconUsers = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx={9} cy={7} r={4} />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </SVG>
);

export const IconBack = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}><polyline points="15 18 9 12 15 6" /></SVG>
);

export const IconPhone = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" /></SVG>
);

export const IconRoute = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <circle cx={6} cy={19} r={3} />
    <path d="M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15" />
    <circle cx={18} cy={5} r={3} />
  </SVG>
);

export const IconCamera = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" />
    <circle cx={12} cy={13} r={4} />
  </SVG>
);

export const IconImage = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <rect x={3} y={3} width={18} height={18} rx={2} ry={2} />
    <circle cx={8.5} cy={8.5} r={1.5} />
    <polyline points="21 15 16 10 5 21" />
  </SVG>
);

export const IconCheck = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}><polyline points="20 6 9 17 4 12" /></SVG>
);

export const IconClose = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <line x1={18} y1={6} x2={6} y2={18} />
    <line x1={6} y1={6} x2={18} y2={18} />
  </SVG>
);

export const IconChevronRight = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}><polyline points="9 18 15 12 9 6" /></SVG>
);

export const IconLock = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <rect x={3} y={11} width={18} height={11} rx={2} ry={2} />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </SVG>
);

export const IconLogout = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1={21} y1={12} x2={9} y2={12} />
  </SVG>
);

export const IconAlert = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
    <line x1={12} y1={9} x2={12} y2={13} />
    <line x1={12} y1={17} x2={12.01} y2={17} />
  </SVG>
);

export const IconRefresh = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <polyline points="1 4 1 10 7 10" />
    <polyline points="23 20 23 14 17 14" />
    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4-4.64 4.36A9 9 0 0 1 3.51 15" />
  </SVG>
);

export const IconPlus = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <line x1={12} y1={5} x2={12} y2={19} />
    <line x1={5} y1={12} x2={19} y2={12} />
  </SVG>
);

export const IconMinus = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}><line x1={5} y1={12} x2={19} y2={12} /></SVG>
);

export const IconSun = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <circle cx={12} cy={12} r={4} />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
  </SVG>
);

export const IconMoon = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </SVG>
);

export const IconSearch = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <circle cx={11} cy={11} r={7} />
    <line x1={21} y1={21} x2={16.65} y2={16.65} />
  </SVG>
);

export const IconSnowflake = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <line x1={12} y1={2} x2={12} y2={22} />
    <line x1={2} y1={12} x2={22} y2={12} />
    <line x1={4.93} y1={4.93} x2={19.07} y2={19.07} />
    <line x1={4.93} y1={19.07} x2={19.07} y2={4.93} />
  </SVG>
);

export const IconWallet = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
    <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
    <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
  </SVG>
);

export const IconDashboard = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <line x1={6} y1={20} x2={6} y2={12} />
    <line x1={12} y1={20} x2={12} y2={4} />
    <line x1={18} y1={20} x2={18} y2={9} />
    <line x1={3} y1={20} x2={21} y2={20} />
  </SVG>
);

export const IconGift = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <polyline points="20 12 20 22 4 22 4 12" />
    <rect x={2} y={7} width={20} height={5} />
    <line x1={12} y1={22} x2={12} y2={7} />
    <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
    <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
  </SVG>
);

export const IconCash = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <rect x={2} y={6} width={20} height={12} rx={2} />
    <circle cx={12} cy={12} r={2.5} />
    <path d="M6 9h.01M18 15h.01" />
  </SVG>
);

export const IconHelp = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <circle cx={12} cy={12} r={10} />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <line x1={12} y1={17} x2={12.01} y2={17} />
  </SVG>
);

export const IconInfo = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <circle cx={12} cy={12} r={10} />
    <line x1={12} y1={16} x2={12} y2={12} />
    <line x1={12} y1={8} x2={12.01} y2={8} />
  </SVG>
);

export const IconHourglass = (p: SVGProps<SVGSVGElement>) => (
  <SVG {...p}>
    <path d="M6 2h12" />
    <path d="M6 22h12" />
    <path d="M17 2v4a5 5 0 0 1-2 4l-3 2 3 2a5 5 0 0 1 2 4v4" />
    <path d="M7 2v4a5 5 0 0 0 2 4l3 2-3 2a5 5 0 0 0-2 4v4" />
  </SVG>
);
